import { Header } from "./Header";
export var Like;
(function (Like) {
    function is(value) {
        return (typeof value == "object" &&
            Object.keys(value).every(key => ["status", "header", "body", "socket"].some(property => property == key)) &&
            (value.status == undefined || typeof value.status == "number") &&
            (value.header == undefined || Header.is(value.header)) &&
            (value.socket == undefined ||
                (typeof value.socket.close == "function" &&
                    typeof value.socket.json?.send == "function" &&
                    typeof value.socket.string?.send == "function" &&
                    typeof value.socket.arrayBuffer?.send == "function")) &&
            (value.status != undefined || value.header != undefined || value.body != undefined));
    }
    Like.is = is;
})(Like || (Like = {}));
//# sourceMappingURL=Like.js.map